import { DashboardSummary } from '../../types';
import api from './client';

/** Read-only dashboard aggregates. */
export const reportsService = {
  /**
   * @param range epoch seconds. Defaults server-side to the last 30 days.
   * @param shopId super admins only — a shop admin is always their own shop.
   */
  getSummary: async (
    range?: { from?: number; to?: number },
    shopId?: string,
  ): Promise<DashboardSummary> => {
    const response = await api.get<DashboardSummary>('/reports/summary', {
      params: { ...range, shopId },
    });
    return response.data;
  },
};
